/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PlayerRestrictionState = {
    _11184809: '11184809',
    BLOCKED: 'BLOCKED',
    PROBATION: 'PROBATION',
    unknown_default_open_api: '11184809'
} as const;
export type PlayerRestrictionState = typeof PlayerRestrictionState[keyof typeof PlayerRestrictionState];


export function instanceOfPlayerRestrictionState(value: any): boolean {
    for (const key in PlayerRestrictionState) {
        if (Object.prototype.hasOwnProperty.call(PlayerRestrictionState, key)) {
            if (PlayerRestrictionState[key as keyof typeof PlayerRestrictionState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PlayerRestrictionStateFromJSON(json: any): PlayerRestrictionState {
    return PlayerRestrictionStateFromJSONTyped(json, false);
}

export function PlayerRestrictionStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerRestrictionState {
    return json as PlayerRestrictionState;
}

export function PlayerRestrictionStateToJSON(value?: PlayerRestrictionState | null): any {
    return value as any;
}

